/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PackageListResponse = zod
	.object({
		packages: zod
			.array(
				zod
					.object({
						generation: zod.number().describe('Package generation number'),
						key: zod.string().describe('Package key identifier'),
						name: zod.string().describe('Package display name')
					})
					.describe('A billing package')
			)
			.describe('Available packages')
	})
	.describe('List of billing packages');

export type PackageListResponse = zod.input<typeof PackageListResponse>;
export type PackageListResponseOutput = zod.output<typeof PackageListResponse>;
